module.exports = __webpack_public_path__ + "img/Hubschrauberlandeplatz.4b5ab7f5.svg";